export default "__VITE_ASSET__AjDuGxQn__"